import { buildNeighborhoodOfficeSeo } from 'ux/Public/OfficeSeo/data/officeSeoNeighborhoodBuild';

export const nycSohoTribecaOfficeSeo = buildNeighborhoodOfficeSeo({
  cityPathSegment: 'new-york',
  neighborhoodSlug: 'soho---tribeca',
  neighborhoodDisplayName: 'SoHo / Tribeca',
  metroDisplayName: 'New York',
  totalCodiClientsInNeighborhood: 3,
  nycLocalPreset: 'manhattanStandard',
  whereFromStreetsToLandmark:
    'from the buildings along Bowery, Broadway, and Grand St to the clusters near Hudson River Park',
  whereTeamStreets: 'Bowery, Broadway, Grand St, Spring St',
  clientDescriptor: 'around 30 people software startup near Bowery',
  clientDescriptorByService: {
    pantryRestocking: 'a small team tech startup near Grand St',
    internet: 'a small team tech startup near Grand St'
  },
  counts: {
    managedCleaningOffices: 1,
    managedPantryOffices: 3,
    managedInternetOffices: 3,
    managedFurnitureOffices: 1,
    managedOfficeAssistantOffices: 1,
    managedDeepCleaningOffices: 1,
    managedCarpetCleaningOffices: 1,
    managedWindowCleaningOffices: 1,
    managedGlassCleaningOffices: 1,
    managedWasteRecyclingOffices: 1,
    managedPantryInventoryOffices: 2,
    managedCoffeeServiceOffices: 2,
    managedWaterServiceOffices: 2,
    managedTeamLunchOffices: 1,
    managedBreakfastCateringOffices: 1,
    managedIndividualMealsOffices: 1,
    managedAdHocCateringOffices: 1,
    managedHappyHourOffices: 1,
    managedConferenceRoomAvOffices: 2,
    managedNetworkInstallationOffices: 3,
    managedNetworkManagementOffices: 2,
    managedCableManagementOffices: 1,
    managedRoomBookingOffices: 1,
    managedPrintingSetupOffices: 2,
    managedInteriorDesignOffices: 2,
    managedOfficeMuralsOffices: 1,
    managedOfficePaintingOffices: 1,
    managedGlassFrostingOffices: 1,
    managedOfficeSignageOffices: 1,
    managedCareRoomOffices: 1,
    managedFurnitureAssemblyOffices: 2,
    managedLayoutChangeOffices: 1,
    managedOfficePlantsOffices: 2,
    managedKeylessAccessOffices: 2,
    managedAlarmSystemsOffices: 1,
    managedSecurityCamerasOffices: 2,
    managedKeypadOffices: 1,
    managedLockboxOffices: 1,
    managedVisitorManagementOffices: 1,
    managedBusinessInsuranceOffices: 2,
    managedElectricalServicesOffices: 5,
    managedHvacOffices: 4,
    managedPlumbingOffices: 4,
    managedPestControlOffices: 3,
    managedOfficeMovingOffices: 5,
    managedMountingInstallationOffices: 7
  },
  quotes: {
    cleaning: 'Seamless move-in experience \u2014 Codi set up cleaning from day one.',
    pantryRestocking: "The pantry was always a pain. Now it's just stocked every week.",
    internet: "Codi coordinated everything with the building ops team so we didn't have to.",
    officeAssistant: 'We needed someone on site who knows the building and the vendors.',
    officeFurniture: "We moved in and the space was already set up. That's what Codi does.",
    deepCleaning:
      'Loft-style SoHo space with high ceilings \u2014 deep cleans require real expertise. Codi handles it.',
    carpetCleaning: 'Creative offices see a lot of wear. Codi keeps our flooring maintained year-round.',
    windowCleaning: 'Street-level SoHo windows attract grime fast. Codi schedules regular cleaning.',
    glassConferenceRoom: 'Our glass-walled meeting room faces the street. Codi keeps it presentable.',
    wasteRecycling: 'Tribeca building has specific waste requirements. Codi manages compliant pickup.',
    pantryInventory:
      'Small SoHo office \u2014 pantry stockouts hit hard. Codi tracks and reorders so it never happens.',
    coffeeService: 'SoHo office standard is good coffee. Codi handles the machine, beans, and upkeep.',
    waterService: 'Filtered water was the first thing we asked Codi to set up. It\u2019s been zero maintenance since.',
    teamLunch: 'Creative team in SoHo \u2014 weekly lunch keeps everyone together. Codi handles all the logistics.',
    breakfastCatering: 'Monday morning kickoff with breakfast. Codi coordinates delivery to our SoHo building.',
    individualMeals: 'Daily lunch for the team in Tribeca. Codi manages the order and delivery every weekday.',
    adHocCatering: 'Client visits, photoshoots, team events \u2014 Codi handles the catering every time.',
    happyHour: 'SoHo happy hour is a vibe. Codi handles the drinks so we can actually enjoy it.',
    conferenceRoomAv:
      'Loft-style SoHo space needed A/V that looked the part. Codi sourced and installed everything cleanly.',
    networkInstallation:
      'Tribeca loft building, complicated riser access. Codi handled COI, building approval, and the full install.',
    networkManagement: 'Codi manages our SoHo office network. Fast response, zero downtime since they took over.',
    cableManagement:
      'Exposed-ceiling SoHo office \u2014 Codi ran cables through conduit and kept everything looking intentional.',
    roomBooking: 'Small Tribeca office with two meeting rooms. Codi deployed a tablet system that the whole team uses.',
    printingSetup:
      'Codi handled printer freight and installation in our SoHo loft. Drivers configured across all devices same day.',
    interiorDesign:
      'SoHo loft office needed a design that matched the neighborhood. Codi did the space plan and managed the full build-out.',
    officeMurals:
      'Creative agency in Tribeca \u2014 we needed a mural that felt authentic. Codi sourced a local artist and managed the install.',
    officePainting:
      'Loft space refresh before a new creative campaign. Codi coordinated after-hours painters and had it done overnight.',
    glassFrosting:
      'Added privacy to the glass meeting room without closing it off. Codi installed frosted film in one visit.',
    officeSignage:
      'SoHo street-facing entrance needed signage that matched the brand. Codi handled design, fabrication, and installation.',
    careRoom:
      'Small Tribeca office with one private room. Codi converted it to a proper care room with furniture and a privacy curtain.',
    furnitureAssembly:
      'Loft office expansion with 15 new workstations. Codi coordinated freight elevator access and assembled everything.',
    layoutChange:
      'Open loft reconfigured for hybrid work. Codi moved modular walls and furniture and had cables rerouted by Monday.',
    officePlants:
      'SoHo creative office with big windows. Codi designed a plant layout that fills the loft space naturally.',
    keylessAccess:
      'SoHo loft office \u2014 keyless access was critical before move-in. Codi installed the system and manages credentials.',
    alarmSystems:
      'Ground-floor Tribeca office needed a monitored alarm. Codi sourced the vendor and handles ongoing coordination.',
    securityCameras:
      'Creative office in SoHo with street-level exposure. Codi installed cameras and manages remote access.',
    keypads: 'Main entry and back door keypads for the SoHo office. Codi installed and manages access codes.',
    lockboxes: 'Codi manages our lockbox for cleaning and courier access. Zero effort from the team.',
    visitorManagement:
      'Client visits and creative shoots mean frequent guests. Codi deployed a visitor check-in system for the Tribeca office.',
    businessInsurance:
      'SoHo loft lease required business insurance COI. Codi sourced our policy and handles renewal coordination.',
    electricalServices:
      'Loft-style SoHo building needed electrical upgrades for modern office use. Codi managed the licensed electrician, DOB permits, and building coordination.',
    hvac: 'HVAC in a converted Tribeca loft required a specialist vendor. Codi manages the service relationship and coordinates all building access.',
    plumbing:
      'SoHo loft buildings have aging plumbing infrastructure. Codi manages a licensed plumber and handles any building notification requirements.',
    pestControl:
      'Ground-floor SoHo location needs proactive pest control. Codi schedules quarterly treatments and maintains compliance documentation.',
    officeMoving:
      'Moving a creative agency with equipment and art into a SoHo loft. Codi managed freight access, mover COI, and the full move-in setup.',
    mountingInstallation:
      'Exposed-brick SoHo office walls required specialist anchoring. Codi managed installation and ensured proper mounting on every surface type.'
  },
  officeAssistant: {},
  metroWideDemandPullquote: ['cleaning', 'officeAssistant', 'officeFurniture']
});
